import { Col, Layout, Result, Row } from "antd";
import moment from "moment";
import { useAppSelector } from "src/app/hooks";
import { selectUser } from "src/appRedux/reducers/userReducer";
import "src/styles/home.css";
import { getDateTime } from "src/util/Commom";

const variables = {
  DATE_FORMAT: {
    DATETIME: "HH:mm DD/MM/YYYY",
    DATE_BEFORE_TIME: "DD/MM/YYYY HH:mm",
    DATE: "DD/MM/YYYY",
    TIME: "HH:mm",
    DATETIME_NO_SPACE: "YYYYMMDDHHmmss",
    DATE_VIEW_VB: "ngày LL",
    YEAR: "YYYY",
    DAY: "DD",
    MONTH: "MM",
  },
};
const Home = () => {
  const authUser = useAppSelector(selectUser);
  const time = new Date();
  const h = time.getHours();
  const m = time.getMinutes();

  return (
    <Layout>
      <div style={{ display: "flex" }}>
        <Col md={12}>
          <h3 style={{ color: "black" }}>Trang chủ</h3>
        </Col>
      </div>
      <div style={{ background: "#ECECEC" }}>
        <Row gutter={16}>
          <Col md={12} span={8} xs={24}>
            <Result
              extra={[]}
              status="success"
              title={`Xin chào ${
                authUser?.user?.hoVaTen
                  ? authUser?.user?.hoVaTen
                  : authUser?.user?.userName
              } !!!`}
            />
          </Col>
          <Col md={12} span={8} xs={24}>
            <div className="block-calendar">
              <div className="heading-block">
                <h3 className="heading">
                  {h < 10 ? `0${h}` : h}:{m < 10 ? `0${m}` : m}
                </h3>
              </div>
              <div className="qti-section-content qti-section-content-calendar">
                <Row>
                  <Col>
                    <div className="calendar-dashboard">
                      <p className="qti-text-day">
                        {moment(time).format("dddd")}
                      </p>
                      <p className="qti-date">
                        {getDateTime({
                          value: moment(time),
                          format: variables.DATE_FORMAT.DAY,
                        })}
                      </p>
                      <p className="qti-month-year">
                        {`
                              THÁNG ${getDateTime({
                                value: moment(time),
                                format: variables.DATE_FORMAT.MONTH,
                              })}
                              NĂM ${getDateTime({
                                value: moment(time),
                                format: variables.DATE_FORMAT.YEAR,
                              })}
                            `}
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Layout>
  );
};

export default Home;
